export const BUSINESS = {
  name: "Oz SpotNest",
  fullName: "Oz SpotNest Cleaning Service",
  tagline: "Spotless Spaces, Happy Places.",
  phone: "0451 415 328",
  phoneHref: "tel:+61451415328",
  email: "info@ozspotnest.com.au",
  emailHref: "mailto:info@ozspotnest.com.au",
  area: "Sydney, NSW",
  address: "4 St Jude Cres, Belmore NSW 2192",
  hours: "7 days · 7:00am – 7:00pm",
  founders: "Vinod & Harry",
  year: new Date().getFullYear(),
};

const img = (id, w = 1200) =>
  `https://images.unsplash.com/${id}?q=80&w=${w}&auto=format&fit=crop`;

export const IMAGES = {
  hero: "https://images.unsplash.com/photo-1758523670739-0d26a3ee976d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzV8MHwxfHNlYXJjaHwyfHxwcm9mZXNzaW9uYWwlMjBjbGVhbmVyJTIwd29ya2luZyUyMGhvbWV8ZW58MHx8fHwxNzg2NDE1MTk2fDA&ixlib=rb-4.1.0&q=85&w=1600&auto=format&fit=crop",
  residential: "https://images.unsplash.com/photo-1758273238415-01ec03d9ef27?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzV8MHwxfHNlYXJjaHwzfHxwcm9mZXNzaW9uYWwlMjBjbGVhbmVyJTIwd29ya2luZyUyMGhvbWV8ZW58MHx8fHwxNzg2NDE1MTk2fDA&ixlib=rb-4.1.0&q=85&w=1200&auto=format&fit=crop",
  commercial: "https://images.unsplash.com/photo-1518455027359-f3f8164ba6bd?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzh8MHwxfHNlYXJjaHwyfHxtb2Rlcm4lMjBvZmZpY2UlMjBjbGVhbmluZyUyMGRlc2t8ZW58MHx8fHwxNzg2NDE1MjAwfDA&ixlib=rb-4.1.0&q=85&w=1200&auto=format&fit=crop",
  care: "https://images.unsplash.com/photo-1762955911431-4c44c7c3f408?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA3MDR8MHwxfHNlYXJjaHwxfHxjYXJlZ2l2ZXIlMjBoZWxwaW5nJTIwZWxkZXJseSUyMGhvbWV8ZW58MHx8fHwxNzg2NDE1MjA1fDA&ixlib=rb-4.1.0&q=85&w=1200&auto=format&fit=crop",
  deep: img("photo-1584820927498-cfe5211fd8bf"),
  bond: img("photo-1600585154340-be6161a56a0c"),
  airbnb: img("photo-1522708323590-d24dbb6b0267"),
  strata: img("photo-1545324418-cc1a3fa10c00"),
  heroBefore: "/images/hero-before.webp",
  heroAfter: "/images/hero-after.webp",
  businessCard: "/images/business-card.webp",
};

export const NAV_LINKS = [
  { label: "Home", to: "/" },
  { label: "Residential", to: "/residential-cleaning" },
  { label: "Commercial", to: "/commercial-cleaning" },
  { label: "NDIS & Aged Care", to: "/ndis-aged-care-cleaning" },
  { label: "About", to: "/about" },
  { label: "FAQ", to: "/faq" },
  { label: "Contact", to: "/contact" },
];

export const PROPERTY_TYPES = [
  "House",
  "Apartment",
  "Townhouse",
  "Office",
  "Commercial Property",
  "Strata / Building",
  "Airbnb / Short-Term Rental",
  "Other",
];

export const SERVICE_OPTIONS = [
  "Regular / Domestic Cleaning",
  "Deep / Spring Cleaning",
  "End-of-Lease / Bond Cleaning",
  "Airbnb / Short-Term Rental Cleaning",
  "Office Cleaning",
  "Strata & Building Cleaning",
  "NDIS Cleaning",
  "Aged Care Cleaning",
  "Other",
];

export const FREQUENCY_OPTIONS = [
  "One-off",
  "Weekly",
  "Fortnightly",
  "Monthly",
  "Ongoing / Custom",
  "Not sure",
];

export const RESIDENTIAL_SERVICES = [
  {
    id: "regular-domestic-cleaning",
    title: "Regular / Domestic Cleaning",
    description:
      "Ongoing cleaning designed to keep your home fresh, tidy and comfortable. Choose a schedule that suits your household, including weekly, fortnightly or monthly cleaning.",
    items: [
      "Surface dusting",
      "Vacuuming",
      "Mopping",
      "Kitchen cleaning",
      "Bathroom sanitation",
      "General tidying",
      "High-touch surface cleaning",
    ],
    cta: "Request a Quote",
    image: IMAGES.residential,
    alt: "Professional cleaner mopping a bright living room floor in a Sydney home",
  },
  {
    id: "deep-spring-cleaning",
    title: "Deep / Spring Cleaning",
    description:
      "A more detailed clean for homes that need extra attention. Ideal for seasonal resets, preparing for an occasion, or tackling areas that don't receive attention during routine cleaning.",
    items: [
      "Built-up grime",
      "Grout",
      "Window tracks",
      "Skirting boards",
      "Vents",
      "Detailed bathroom cleaning",
      "Detailed kitchen cleaning",
      "Areas behind or around furniture where accessible",
    ],
    cta: "Request a Deep Clean",
    image: IMAGES.deep,
    alt: "Professional cleaning products and equipment ready for a deep clean",
  },
  {
    id: "end-of-lease-bond-cleaning",
    title: "End-of-Lease / Bond Cleaning",
    description:
      "Detailed rental cleaning designed around the expectations of property managers and real estate agents when a tenancy ends.",
    items: [
      "Kitchen",
      "Bathrooms",
      "Floors",
      "Surfaces",
      "Fixtures",
      "Skirting boards",
      "Window tracks",
      "General rental-property cleaning",
    ],
    note: "Cleaning requirements can vary between properties and tenancy agreements. Ask us about your property's specific requirements.",
    cta: "Get a Bond Clean Quote",
    image: IMAGES.bond,
    alt: "Modern Sydney home interior prepared for end-of-lease inspection",
  },
  {
    id: "airbnb-short-term-rental-cleaning",
    title: "Airbnb & Short-Term Rental Cleaning",
    description:
      "Fast, reliable turnover cleaning to help short-term rental properties stay guest-ready between bookings.",
    items: [
      "Full property cleaning",
      "Bathroom cleaning",
      "Kitchen cleaning",
      "Bedroom preparation",
      "Linen changes",
      "Restocking of agreed amenities",
      "Final presentation check",
    ],
    cta: "Ask About Airbnb Cleaning",
    image: IMAGES.airbnb,
    alt: "Bright short-term rental apartment styled and ready for guests",
  },
];

export const COMMERCIAL_SERVICES = [
  {
    id: "office-cleaning",
    title: "Office Cleaning",
    description:
      "Regular professional cleaning that keeps your workplace clean, hygienic and presentable for staff, clients and visitors.",
    items: [
      "Workstations",
      "Common areas",
      "Kitchens",
      "Restrooms",
      "Floors",
      "High-touch areas",
      "Waste management",
    ],
    cta: "Request a Commercial Quote",
    image: IMAGES.commercial,
    alt: "Clean modern office space maintained with regular professional cleaning",
  },
  {
    id: "strata-building-cleaning",
    title: "Strata & Building Cleaning",
    description:
      "Reliable common-area cleaning for strata managers, building managers, property managers, owners corporations and commercial property managers.",
    items: [
      "Hallways",
      "Foyers",
      "Stairwells",
      "Lift interiors",
      "Common areas",
      "Shared facilities",
      "General building presentation",
    ],
    cta: "Request a Building Cleaning Quote",
    image: IMAGES.strata,
    alt: "Apartment building with well-maintained shared spaces",
  },
];

export const WHY_CHOOSE_US = [
  {
    title: "Reliable Service",
    description: "We understand that customers need cleaners they can depend on.",
    icon: "ShieldCheck",
  },
  {
    title: "Attention to Detail",
    description:
      "We focus on the areas that make a real difference to how a property looks and feels.",
    icon: "Sparkles",
  },
  {
    title: "Flexible Cleaning Options",
    description:
      "Choose one-off, recurring, scheduled, turnover or specialised cleaning depending on your needs.",
    icon: "CalendarCheck",
  },
  {
    title: "Clear Communication",
    description:
      "It's easy to ask questions, request a quote and understand exactly what is included.",
    icon: "MessagesSquare",
  },
  {
    title: "Residential & Commercial",
    description: "One cleaning business for homes, rental properties, offices and buildings.",
    icon: "Building2",
  },
  {
    title: "Customer-Focused",
    description:
      "We aim to understand each property's requirements and provide cleaning suited to the job.",
    icon: "HeartHandshake",
  },
];

export const HOW_IT_WORKS = [
  {
    step: "01",
    title: "Tell Us What You Need",
    description: "Complete the quote form or contact us by phone or email.",
  },
  {
    step: "02",
    title: "We Discuss Your Property",
    description:
      "We'll understand the property, cleaning requirements, frequency and any important details.",
  },
  {
    step: "03",
    title: "Receive Your Quote",
    description: "You'll get a clear quote based on your cleaning requirements.",
  },
  {
    step: "04",
    title: "Schedule Your Cleaning",
    description: "Choose a suitable time and get your property cleaned.",
  },
];

export const FAQS = [
  {
    q: "What areas do you service?",
    a: "We're based in Belmore NSW and provide cleaning services across Sydney, NSW. If you're not sure whether we cover your area, get in touch and we'll confirm.",
  },
  {
    q: "Do you offer regular cleaning?",
    a: "Yes. We offer recurring cleaning options such as weekly, fortnightly and monthly, subject to availability.",
  },
  {
    q: "Do you offer one-off cleaning?",
    a: "Yes, one-off cleans are available where our schedule allows.",
  },
  {
    q: "Do you offer deep cleaning?",
    a: "Yes. Our deep / spring cleaning service is a more detailed clean for homes that need extra attention, including areas that don't get covered in routine cleaning.",
  },
  {
    q: "Do you offer end-of-lease cleaning?",
    a: "Yes. Our end-of-lease / bond cleaning is designed around the expectations of property managers and real estate agents when a tenancy ends. Requirements can vary between properties and tenancy agreements, so ask us about your property's specific needs.",
  },
  {
    q: "Do you clean Airbnb properties?",
    a: "Yes, including turnover cleaning, linen changes and restocking of agreed amenities between bookings.",
  },
  {
    q: "Do you clean offices?",
    a: "Yes. We clean offices and commercial premises, including workstations, common areas, kitchens, restrooms, floors, high-touch areas and waste management.",
  },
  {
    q: "Do you clean strata buildings?",
    a: "Yes, including common areas such as foyers, hallways, stairwells, lift interiors and shared facilities.",
  },
  {
    q: "Do you provide NDIS cleaning?",
    a: "We provide cleaning and home maintenance support for NDIS participants where the service is appropriate to their circumstances, plan and funding arrangements. Contact us to discuss your situation.",
  },
  {
    q: "Do you provide aged-care cleaning?",
    a: "Yes. Cleaning support can be tailored to the customer's needs, preferences and routine.",
  },
  {
    q: "How much does cleaning cost?",
    a: "Pricing depends on factors such as property size, type of cleaning, condition of the property, number of rooms, frequency, cleaning requirements, location and any additional services. Request a free quote and we'll price your specific job.",
  },
  {
    q: "Can I book recurring cleaning?",
    a: "Yes, recurring cleaning is available subject to availability. Weekly, fortnightly and monthly options are available.",
  },
  {
    q: "Do I need to provide cleaning products?",
    a: "Please ask us what equipment and cleaning products are included with your service when you request your quote.",
  },
  {
    q: "Can I request a specific cleaning time?",
    a: "Cleaning times are subject to availability. Contact us with your preferred date and time and we'll do our best to accommodate you.",
  },
];
